import React from 'react';
import moment from 'moment';
import { useNotification } from './NotificationProvider.js';

const NotificationCard = ({
  listData = [],
  isReaded = false,
  selfName,
  onNotificationClick,
}) => {
  const {
    setPanelVisible,
    setThreadData,
    markAsRead,
    externalClients,
    beforeJump,
    checkUserOnSamePage,
    urlMap,
    history,
    dateFormatter = (dateString) =>
      moment(dateString).format(`HH:mm A [ET]   MMM DD YYYY`),
  } = useNotification() || {};

  const onClickCallback = (msg) => {
    const { id } = msg;
    markAsRead(id);
    setThreadData((prev) => {
      const i = prev.findIndex((e) => e.id === id);
      prev[i].readStatus = true;
      return prev;
    });
  };

  const { accessibleModules } = useNotification();

  return (
    <>
      {listData && listData.length
        ? listData.map((msg, index) => {
            let msgContent = msg.notificationContent || {};
            if (typeof msgContent === 'string') {
              msgContent = JSON.parse(msgContent);
            }
            const isClient =
              externalClients.findIndex(
                (e) => e.email === msgContent.userEmail,
              ) !== -1;
            return (
              <div
                className="notification-card-wrapper"
                key={msg.notificationId || index}
                onClick={() => {
                  typeof onNotificationClick === 'function' &&
                    onNotificationClick(
                      msg,
                      setPanelVisible,
                      history,
                      () => onClickCallback(msg),
                      beforeJump,
                      checkUserOnSamePage,
                      urlMap,
                      accessibleModules,
                    );
                }}
              >
                <div className="notification-card-user">
                  <span
                    className={`notification-username ${
                      isReaded ? 'readed-username' : ''
                    }`}
                  >
                    {msgContent.userName || selfName || ' '}
                    {isClient ? `(Client)` : ''}
                  </span>
                  <span
                    className={`notification-datetime ${
                      isReaded ? 'readed-datetime' : ''
                    }`}
                  >
                    {msg.createdAt && dateFormatter(msg.createdAt)}
                  </span>
                </div>

                <div
                  className={`notification-message ${
                    isReaded ? 'readed-message' : ''
                  }`}
                >
                  {msgContent.message}
                </div>

                {!isReaded && !msg.readStatus && <div className="unread-dot" />}
              </div>
            );
          })
        : null}
    </>
  );
};

export default NotificationCard;
